import React from 'react';
import { Text } from '@radix-ui/themes';
import roleplayIcon from '../../../../assets/images/roleplay.png';

const RpWait = () => {
  return (
    <div className="flex flex-1 justify-center items-center">
      <img
        src={roleplayIcon}
        alt="Roleplay"
        className="h-[20vh] w-[35vw] max-h-[150px] max-w-[200px] object-contain"
      />
      <Text
        as="span"
        size="4"
        className="text-white py-[1.5vh] font-[Lato-Regular] text-center w-[60vw] mb-[1vh] whitespace-pre-line"
      >
        Trainer would like you to volunteer for group presentations{'\n'}Group Leaders to volunteer NOW
      </Text>
    </div>
  );
};

export default RpWait;